import React from "react";
import { CircularProgress } from "@material-ui/core";

import { getMovAssetCompProvider } from "../../../../../../../../providers/asset-provider";

class MovementAssetComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading: false
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    getMovAssetCompProvider()
      .then(data => {
        this.setState({
          data,
          loading: false
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.error("getMovAssetCompProvider", error);
      });
  }

  render() {
    if (this.state.loading) {
      return (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
          <span
            style={{
              marginTop: 20
            }}
          >
            Loading...
          </span>
        </div>
      );
    }

    return (
      <div
        style={{
          height: "100%",
          width: "100%"
        }}
      >
        MovementAssetComponent
      </div>
    );
  }
}

export default MovementAssetComponent;
